import React, { FC } from "react";
import SelectInput from "@/components/selectInput/SelectInput";
import { Package } from "@/interfaces/Package";
import deleteIcon from "../../../../assets/icons/deleteIcon.svg";
import { FiEdit2, FiInfo } from "react-icons/fi";

interface ManagePackageProps {
    packageList: Package[];
    curPackage: Package | null | undefined;
    livePackageId: string;
    showPackageIncludesInfo?: boolean;
    packageIncludesHtml?: string;
    onSelectPackage: (pkg: Package) => void;
    onEditPackage: () => void;
    onDeletePackage: (packageId?: string) => void;
    onAddNewPackage: () => void;
}

const ManagePackage: FC<ManagePackageProps> = ({
    packageList,
    curPackage,
    livePackageId,
    showPackageIncludesInfo,
    packageIncludesHtml,
    onSelectPackage,
    onEditPackage,
    onDeletePackage,
    onAddNewPackage,
}) => {
    const curKey = curPackage?.id || curPackage?.name;
    const isLive = !!curPackage?.id && curPackage.id === livePackageId;

    if (!packageList || packageList.length === 0) {
        return null;
    }

    return (
        <div className="w-full flex flex-wrap items-center gap-3 mt-5">
            <div
                onClick={onAddNewPackage}
                className="bg-black text-white cursor-pointer rounded-full py-2 px-6 w-36 flex items-center gap-1"
            >
                <span className="text-lg">+</span> Add New
            </div>
            <div className="min-w-[220px]">
                <SelectInput
                    classes="max-w-xs"
                    bg="bg-white"
                    disabled={false}
                    value={curKey}
                    onChange={(e: string) => {
                        const selected = packageList.find(
                            (pkg) => (pkg.id || pkg.name) === e
                        );
                        if (selected) onSelectPackage(selected);
                    }}
                    options={packageList.map((pkg) => ({
                        value: pkg.id || pkg.name,
                        label: pkg.name,
                    }))}
                />
            </div>
            {showPackageIncludesInfo && (
                <div
                    data-tooltip-id="watch-video-tooltip"
                    data-tooltip-html={packageIncludesHtml}
                    className="p-2 rounded-full cursor-pointer bg-p-gray"
                >
                    <FiInfo size={12} />
                </div>
            )}
            {!isLive && curPackage && (
                <div
                    data-tooltip-id="watch-video-tooltip"
                    data-tooltip-content="Edit package"
                    className="p-2 rounded-full cursor-pointer bg-p-gray"
                    onClick={onEditPackage}
                >
                    <FiEdit2 size={12} />
                </div>
            )}
            {!isLive && curPackage?.id && (
                <div
                    data-tooltip-id="watch-video-tooltip"
                    data-tooltip-content="Delete package"
                    className="p-2 rounded-full cursor-pointer bg-p-gray"
                    onClick={() => onDeletePackage(curPackage.id)}
                >
                    <img src={deleteIcon} className="min-w-3" />
                </div>
            )}
        </div>
    );
};

export default ManagePackage;
